import React from 'react';
import { heroData } from '../data/mockData';

const Hero = () => {
  return (
    <div className="relative w-full h-screen overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url('${heroData.backgroundImage}')` }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80"></div>
      </div>

      {/* Content */}
      <div className="relative h-full flex flex-col items-center justify-center px-4 text-center">
        <h1 className="text-3xl sm:text-5xl md:text-7xl font-light text-white tracking-[0.15em] md:tracking-[0.3em] mb-6 max-w-[100vw] break-words">
          {heroData.title}
        </h1>
        <div className="w-24 h-px bg-gradient-to-r from-transparent via-gold to-transparent mb-6"></div>
        <p className="text-lg sm:text-xl md:text-2xl text-white/80 font-light tracking-wider max-w-sm sm:max-w-none mx-auto">
          {heroData.tagline}
        </p>
        
        {/* Scroll Indicator */}
        <button 
          onClick={() => document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' })}
          className="absolute bottom-8 md:bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce cursor-pointer group"
          aria-label="Scroll to projects"
        >
          <div className="w-px h-8 md:h-12 bg-gradient-to-b from-transparent to-gold group-hover:to-gold/80 transition-colors"></div>
          <span className="text-xs text-white/60 tracking-widest mr-[-0.1em] group-hover:text-white transition-colors">EXPLORE</span>
        </button>
      </div>
    </div>
  );
};

export default Hero;
